import { useEffect } from "react";
import { Outlet } from "react-router";
import { fetchListTemplates } from "stores/actions/list-templates";
import { fetchLists } from "stores/actions/lists";

const AdminProvider = () => {
  useEffect(() => {
    // fetch some data needed in admin views
    fetchListTemplates();
    fetchLists();
  }, []);

  // no need to wait for listtemplates or lists, they are array
  return <Outlet />;
};

export default AdminProvider;
